import { autoFormat } from 'app-lib/numberUtils'
import { IAirdropInfo } from 'bzx-common/src/services/AirdropService'
import { observer } from 'mobx-react'
import React from 'react'
import { Button } from 'ui-framework'
import CompensationVM from './CompensationVM'

export function Claim({ vm, compensation }: { vm: CompensationVM; compensation: IAirdropInfo }) {
  const badBoyMode = vm.isBadBoy && compensation.amount.gt(0)
  const tokenName = badBoyMode ? 'vBZRX' : 'BZRX'
  const { amount, userClaimed } = compensation
  const canClaim =
    amount.gt(0) && !userClaimed && vm.approvalsAreSafe && vm.inputAddressEqualConnected
  const isBzrxLocked = compensation.airdrop === 'BZRX_LOCKED'

  if (!compensation.token.address) {
    return null
  }

  if (vm.isBadBoy && compensation.airdrop !== 'BZRX_COMPENSATION1') {
    return null
  }

  return (
    <div className="panel--alternative padded-1 margin-bottom-1">
      <div className="flex-row-center justify-between flex-wrap">
        <div>
          <h4 className="txt-subtitle margin-0">{compensation.airdrop}</h4>
          <div>
            Entitled to{' '}
            <b className="txt-positive" title={compensation.amount.toFixed()}>
              {autoFormat(compensation.amount)}
            </b>{' '}
            {tokenName}.
          </div>
        </div>

        {vm.canCheck && badBoyMode && compensation.airdrop === 'BZRX_COMPENSATION1' && (
          <Button variant="green" disabled>
            Claim Soon
          </Button>
        )}

        {!vm.isBadBoy && !userClaimed && (
          <Button
            variant="green"
            className="btn--responsive"
            disabled={!canClaim}
            isLoading={vm.airdropStore.airdropPending}
            onClick={
              isBzrxLocked
                ? vm.airdropStore.claimLockedBZRXCompensation
                : vm.airdropStore.claimBZRXCompensation
            }
            onClickEmit="value"
            value={isBzrxLocked ? compensation.airdropIndex : compensation.airdrop}>
            Claim
          </Button>
        )}
      </div>

      {vm.canCheck && badBoyMode && compensation.airdrop === 'BZRX_COMPENSATION1' && (
        <p>Team claim comes later</p>
      )}

      {userClaimed && <p className="txt-warning margin-top-1">You have already claimed.</p>}
    </div>
  )
}

export default observer(Claim)
